import React, { Fragment } from 'react';
import solutions from '../../Assets/images/Book.png';
import CompleteSolution from './CompleteSolution';

const Solutions = ({ surveyCompleted }) => {
  return (
    <div className="solution-card">
      {surveyCompleted ? (
        <CompleteSolution />
      ) : (
        <Fragment>
          <h4>Action Steps</h4>
          <div className="report-body">
            <img src={solutions} alt="solutions" />
            <p>
              Recommended solutions will be shown after you have completed
              your first few surveys.
            </p>
          </div>
        </Fragment>
      )}
    </div>
  );
};

export default Solutions;
